import { matchRoutes } from 'react-router-dom'
import { routes } from 'src/router'
import { handleDeviceDetect } from 'src/provider/ChannelContextProvider'

/**
 * 현재 pathname을 라우트 패턴으로 정규화하여 반환
 * - 모든 동적 세그먼트(:couponNumber 등)를 파라미터명 형태로 치환
 * - 매칭되는 라우트가 없으면 '/unknown' 반환
 *
 * @example
 * /aos/coupon/purchase/GIFT/123/010-1234-5678
 * → /coupon/purchase/:couponType/:couponIdx/:couponNumber
 */
export function sanitizeSentryPage(pathname?: string): string {
  const path = pathname ?? window.location.pathname
  const { channel } = handleDeviceDetect()

  const normalizedPath = path.replace(new RegExp(`^/${channel}`), '')

  const matches = matchRoutes(
    routes.map((r) => ({ path: r.path })),
    normalizedPath,
  )

  if (!matches?.length) return '/unknown'

  const routePath = matches.at(-1)?.route.path ?? '/unknown'
  return routePath
}

/**
 * 전체 URL을 Sentry 전송 안전한 형태로 마스킹하여 반환
 * - 동적 세그먼트를 라우트 패턴으로 치환
 * - query string / hash 제거
 * - beforeSend에서 event.request.url, event.tags.url 마스킹에 사용
 *
 * @example
 * https://svc.couponwallet.co.kr/ios/coupon/purchase/GIFT/123/010-1234-5678
 * → https://svc.couponwallet.co.kr/ios/coupon/purchase/:couponType/:couponIdx/:couponNumber
 */
export function sanitizeSentryUrl(raw: string): string {
  try {
    const url = new URL(raw, window.location.origin)
    const { channel } = handleDeviceDetect()
    const pattern = sanitizeSentryPage(url.pathname)
    return `${url.origin}/${channel}/${pattern}`
  } catch {
    return sanitizeSentryPage(raw)
  }
}
